"use client";

import CtaBand from "@/components/common/CtaBand";
import { useLanguage } from "@/hooks/useLanguage";
import { pick } from "@/lib/i18n";
export default function QuoteRequest() {
  const {
    lang
  } = useLanguage();
  return <CtaBand id="quoterequestcta" eyebrow={pick(lang, {
    en: "B2B Industrial Filtration Mesh",
    zh: "B2B 工业过滤丝网",
    es: "Malla de filtración industrial B2B",
    de: "B2B-Industriefiltergewebe",
    fr: "Toile de filtration industrielle B2B",
    pt: "Malha de filtração industrial B2B"
  })} heading={pick(lang, {
    en: "Need a Specific Product Specification?",
    zh: "需要特定的产品规格？",
    es: "¿Necesita una especificación de producto específica?",
    de: "Benötigen Sie eine bestimmte Produktspezifikation?",
    fr: "Vous avez besoin d'une spécification de produit particulière ?",
    pt: "Precisa de uma especificação de produto específica?"
  })} lead={pick(lang, {
    en: "MutualFilter can assist in matching products to your required specifications, engineering drawings, or application requirements.",
    zh: "MutualFilter 可根据您的具体技术规格、工程图纸或应用要求，协助匹配适用的产品配置。",
    es: "MutualFilter puede ayudarle a seleccionar los productos adecuados según sus especificaciones, planos de ingeniería o requisitos de aplicación.",
    de: "MutualFilter unterstützt Sie bei der Abstimmung von Produkten auf Ihre Spezifikationen, Konstruktionszeichnungen oder Anwendungsanforderungen.",
    fr: "MutualFilter peut vous aider à adapter les produits à vos spécifications requises, plans d'ingénierie ou exigences d'application.",
    pt: "A MutualFilter pode auxiliar na seleção de produtos adequados de acordo com suas especificações, desenhos de engenharia ou requisitos de aplicação."
  })} primary={{
    to: "/RequestAQuotePage",
    label: pick(lang, {
      en: "Request a Quote",
      zh: "索取报价",
      es: "Solicitar presupuesto",
      de: "Angebot anfragen",
      fr: "Demander un devis",
      pt: "Solicitar orçamento"
    })
  }} secondary={{
    to: "/ContactPage",
    label: pick(lang, {
      en: "Contact Our Team",
      zh: "联系我们",
      es: "Contacte con nosotros",
      de: "Kontakt aufnehmen",
      fr: "Nous contacter",
      pt: "Fale conosco"
    })
  }} />;
}